import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { getRecentlySearchedProductsServer } from '@util/firestore/products/products.typesense';
import useSearchHistory from '@util/hooks/useSearchHistory';
import { logError } from '@util/logError';
import { useAuth } from 'context/AuthContext';
import { useMemo } from 'react';

export const useRecentlySearched = () => {
  const { user } = useAuth();
  const { searches, isLoading: isHistoryLoading } = useSearchHistory({
    uid: user?.uid,
  });
  const mostRecentTerm = useMemo(
    () => searches.filter((s) => s !== '').at(-1),
    [searches]
  );

  const { data = [], isLoading: loadingQuery } = useQuery({
    queryKey: ['recentlySearchedProducts', user?.uid, mostRecentTerm],
    queryFn: async () => {
      try {
        if (!mostRecentTerm) return [];
        return getRecentlySearchedProductsServer(mostRecentTerm);
      } catch (error) {
        logError(error, 'Error fetching recently searched products:');
        return [];
      }
    },
    enabled: !!user?.uid && !!mostRecentTerm,
    staleTime: 1000 * 60 * 10,
    placeholderData: keepPreviousData,
    notifyOnChangeProps: ['data'], // only notify when data changes
  });
  const loadingUser = user === undefined;
  return {
    recentlySearchedProducts: data,
    isLoading:
      (loadingUser || loadingQuery || isHistoryLoading) && !data.length, // could come from prevData
    mostRecentTerm,
  };
};
